module.exports = __webpack_public_path__ + "img/icon-card.dd96d8f8.svg";